import React, { Component, createRef } from "react";
import commonFunction from "../../../lib/utils/common.js";
import configUrl from "../../../../config/config.json";
import { logout } from "../../../lib/logout";
import Menu from "../../Menu/index";
import {
  setTockenInCoockie,
  getCookieTocken,
  removeUserTokenFromCookie,
} from "../../login/userToken.js";
import { checksession } from "../../../lib/checksession";
import Link from "../../../Link.js";
import chat from "../../../lib/chat.js";
import FBPixCodeScript from "../../../analytics/FacebookPixelCode.js";
import UploadLogo from "store/uploadLogo";

// let MenuList=[
//     {name:'My Profile',href:'profile', activeimg:'/images/my-profile-g.svg',inactiveimg:'/images/my-profile-g.svg'},
//     {name:'My Booking',href:'mybooking',activeimg:'/images/my-booking-g.svg',inactiveimg:'/images/my-booking-g.svg'},
//     {name:'Guest & Traveler',href:'guesttraveler', activeimg:'/images/guestTravel-g.svg',inactiveimg:'/images/guestTravel-g.svg/images/prefernce-g.svg'},
//     {name:'Travel Preferences',href:'travelpreferences', activeimg:'/images/prefernce-g.svg',inactiveimg:'/images/prefernce-g.svg'},
//     {name:'Communication Preferences',href:'compreferences', activeimg:'/images/prefernce-g.svg',inactiveimg:'/images/prefernce-g.svg'},
//     {name:'My Frequent Flyer',href:'frequentflyer', activeimg:'/images/flyer-g.svg',inactiveimg:'/images/flyer-g.svg'},
//     {name:'Email Notifications',href:'emailnotifications', activeimg:'/images/Email-notifications-g.svg',inactiveimg:'/images/Email-notifications-g.svg'},
//     {name:'Change Password',href:'changepassword', activeimg:'/images/changePwd-g.svg',inactiveimg:'/images/changePwd-g.svg'},
//     {name:'Logout',href:'Logout', activeimg:'/images/Logout-g.svg',inactiveimg:'/images/Logout-g.svg'}
//   ]

let MenuList = [
  {
    Linkindex: 0,
    isPartition: false,
    linkItem: "My Profile",
    isActiveLink: true,
    componentName: "ProfileForm",
    imgInActiveSrc: "/images/my-profile-g.svg",
    imgActiveSrc: "/images/my-profile-g.svg",
    href: "profile",
  },
  {
    Linkindex: 1,
    isPartition: false,
    linkItem: "My Booking",
    isActiveLink: false,
    componentName: "BookingForm",
    imgInActiveSrc: "/images/my-booking-g.svg",
    imgActiveSrc: "/images/my-booking-g.svg",
    href: "mybooking",
  },
  {
    Linkindex: 2,
    isPartition: false,
    linkItem: "Guest & Traveler",
    isActiveLink: false,
    componentName: "GuestTravelerForm",
    imgInActiveSrc: "/images/guestTravel-g.svg",
    imgActiveSrc: "/images/guestTravel-g.svg",
    href: "guesttraveler",
  },
  {
    Linkindex: 3,
    isPartition: false,
    linkItem: "Travel Preferences",
    isActiveLink: false,
    componentName: "TravelPreferencesForm",
    imgInActiveSrc: "/images/prefernce-g.svg",
    imgActiveSrc: "/images/prefernce-g.svg",
    href: "travelpreferences",
  },
  // { Linkindex: 4, isPartition: false, linkItem: 'Communication Preferences', isActiveLink: false, componentName: 'CompreferencesForm', imgInActiveSrc: '/images/prefernce-g.svg', imgActiveSrc: '/images/prefernce-g.svg', href:'compreferences' },
  // { Linkindex: 5, isPartition: false, linkItem:'Coupons & More', isActiveLink: false,  componentName: 'CouponsMoreForm', imgInActiveSrc: '/images/coupon-g.svg', imgActiveSrc: '/images/coupon-g.svg' },
  {
    Linkindex: 6,
    isPartition: false,
    linkItem: "My Frequent Flyer",
    isActiveLink: false,
    componentName: "FrequentFlyerForm",
    imgInActiveSrc: "/images/flyer-g.svg",
    imgActiveSrc: "/images/flyer-g.svg",
    href: "frequentflyer",
  },
  // { Linkindex: 7, isPartition: false, linkItem:'My Wallet', isActiveLink: false,  componentName: 'WalletForm', imgInActiveSrc: '/images/wallet-g.svg', imgActiveSrc: '/images/wallet-g.svg' },
  // { Linkindex: 8, isPartition: false, linkItem:'Payments & More', isActiveLink: false,  componentName: 'PaymentsMoreForm', imgInActiveSrc: '/images/payment-g.svg', imgActiveSrc: '/images/payment-g.svg' },
  // { Linkindex: 9, isPartition: false, linkItem: 'Email notifications', isActiveLink: false, componentName: 'EmailNotificationsForm', imgInActiveSrc: '/images/Email-notifications-g.svg', imgActiveSrc: '/images/Email-notifications-g.svg',href:'emailnotifications' },
  {
    Linkindex: 10,
    isPartition: false,
    linkItem: "Change Password",
    isActiveLink: false,
    componentName: "ChangePasswordForm",
    imgInActiveSrc: "/images/changePwd-g.svg",
    imgActiveSrc: "/images/changePwd-g.svg",
    href: "changepassword",
  },
  {
    Linkindex: 11,
    isPartition: false,
    linkItem: "Logout",
    isActiveLink: false,
    componentName: "Logout",
    imgInActiveSrc: "/images/Logout-g.svg",
    imgActiveSrc: "/images/Logout-g.svg",
    href: "Logout",
  },
];

class MobileHeader1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToken: "",
      isShowPopup: false,
      userFirststname: "",
      userLaststname: "",
      open: false,
      scrolling: false,
    };
    this.supportWrapperRef = createRef();
  }

  setSupportWrapperRef = (node) => {
    this.supportWrapperRef = node;
  };

  handleCalendarClickOutside = (event) => {
    if (
      !this.supportWrapperRef ||
      !this.supportWrapperRef.contains(event.target)
    ) {
      this.setState({ openSupportPopup: false });
    }
  };

  componentDidMount() {
    /* this.setState({
            newToken: getCookieTocken("userToken") !== undefined && getCookieTocken("userToken") !== null && getCookieTocken("userToken") !== "" && getCookieTocken("userToken")
        }/* , () => {

            this.state.newToken && this.checkSessionApi()
        } )*/
    console.log("this.props.data.user", this.props.data.user);
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("mousedown", this.handleCalendarClickOutside);

    chat(this.props?.data?.siteData?.site?.chat, this.props?.data?.isMobile);
    if (this.props?.data?.user?.status) {
      this.setState({
        userFirststname: this.props?.data?.user?.first_name
          ? this.props?.data?.user?.first_name.charAt(0)
          : this.props?.data?.user?.email.charAt(0),
        userLaststname: this.props?.data?.user?.first_name
          ? this.props?.data?.user?.last_name.charAt(0)
          : this.props?.data?.user?.email.charAt(0),
        newToken: this.props?.data?.user?.accessToken || "",
      });
    } else {
      this.setState({
        userFirststname: "",
        userLaststname: "",
        newToken: "",
      });
    }

    // console.log("newTokennewTokennewTokennewToken",this.state.newToken)
  }
  checkSessionApi = () => {
    // console.log("checkSessionApicheckSessionApi called")
    // let checksessionreq = {
    //     "accessToken": this.state.newToken
    // }
    // checksession(checksessionreq).then((responseJSON) => {
    //     if (responseJSON.status === true && !commonFunction.isValueEmpty(responseJSON.first_name)) {
    //         let firstChar = responseJSON.first_name.charAt(0)
    //         this.setState({
    //             userFirststname: firstChar
    //         }, () => {
    //         })
    //     } else {
    //     }
    // }).catch(err => {
    //     console.log("error", err)
    // })
  };
  onClickArrow = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };
  onMouseLeave = () => {
    // console.log("onMouseLeaveonMouseLeave")
    this.setState({
      isShowPopup: false,
    });
  };

  // componentWillReceiveProps(state, props) {
  //     this.setState({
  //         newToken: getCookieTocken("userToken") !== undefined && getCookieTocken("userToken") !== null && getCookieTocken("userToken") !== "" && getCookieTocken("userToken")
  //     }, () => {
  //         this.state.newToken && this.checkSessionApi()
  //     })
  // }
  onClickProfile = () => {
    commonFunction.redirectTo("/myprofile");
  };
  onClickLogout = () => {
    // let logoutreq = {
    //     "accessToken": this.state.newToken
    // }
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status &&
          responseJSON.message === "Logout successfull"
        ) {
          this.setState({
            newToken: "",
            userFirststname: "",
            userLaststname: "",
          });
          location.reload();
          // commonFunction.redirectTo('/')
          // } else {
          //     this.setState({});
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
    // this.setState({
    // isToken=''
    // })
    // this.props.data.setLoginTokenData=""
  };

  onClickMenu = (bool) => {
    this.setState({ open: bool });
  };

  onClickTab = (id) => {
    // console.log("id=========>", id);
    let newdata = MenuList.map((fact, index) => {
      if (id == index) {
        let data = {
          ...fact,
          active: true,
        };
        return data;
      } else {
        let data = {
          ...fact,
          active: false,
        };
        return data;
      }
    });
    MenuList = newdata;
    this.setState({ open: false });
  };

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("mousedown", this.handleCalendarClickOutside);
  };

  handleScroll = (event) => {
    // console.log("clicked");
    if (window.scrollY <= 100 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
      // console.log("false");
    } else if (window.scrollY > 100 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
      // console.log("true");
    }
  };

  render() {
    console.log("mobile heder=====>", this.props?.data);
    return (
      <header className="mobile-header theme5">
        <FBPixCodeScript />
        {/* <div>Mobile Header
            <div className={props.data.cssfile.main_logo_header}>
                <div className={props.data.cssfile.logo_header}>
                <img  className={props.data.cssfile.header_logo} src={`${'/shared/api/media/6124e1368ede4f08bf2d9ad4/'+props.data.headermenu.logo}`} alt="logo" />

                </div>
                </div>

                <div className={styles.logosub_header}>
                    <img className={styles.search_icon} src="../images/searchOption.png" />
                    <img className={styles.call_icon} src="./images/callOption.png" />
                    <img className={styles.login_icon} src="../images/profileOption.png" />

                </div>
            </div> */}

        {this.props.data.pathname === "/myprofile" ? null : (
          <div
            className={`${this.props.data.cssfile.main_logo_header}  ${
              this.state.scrolling === true
                ? this.props.data.cssfile.header_stickyMobile
                : ""
            }`}
          >
            <div className={this.props.data.cssfile.logosub_header}>
              {/* <img className={this.props.data.cssfile.search_icon} src="../images/searchOption.png" /> */}
              {/* {(this.props?.data?.headermenu?.is_show_login == undefined || this.props?.data?.headermenu?.is_show_login) && <a href="tel:+971 58 953 9988"><h2><img className={this.props.data.cssfile.call_icon} src="images/call_-01.svg" alt="Call" /></h2></a>} */}
              {/* <img className={this.props.data.cssfile.login_icon} src="../images/profileOption.png" onClick={this.props.data.onClickHeaderLogin} /> */}
              {this.props?.data?.headermenu?.is_show_login == undefined ||
              this.props?.data?.headermenu?.is_show_login ? (
                this.state.newToken != undefined &&
                this.state.newToken != null &&
                this.state.newToken != "" ? (
                  <div
                    className={this.props.data.cssfile.afterlogin}
                    onClick={() => {
                      window.location.href = "/myprofile";
                    }}
                  >
                    <span
                      className={this.props.data.cssfile.user_code}
                      onClick={() => {
                        this.onClickMenu(!this.state.open);
                      }}
                    >
                      {this.state.userFirststname}
                      {this.state.userLaststname}
                    </span>
                  </div>
                ) : (
                  <span
                    className={this.props.data.cssfile.login_btn}
                    onClick={this.props.data.onClickHeaderLogin}
                  >
                    {/* <img className={this.props.data.cssfile.login_icon} src="images/user-login-mob1.svg" onClick={this.props.data.onClickHeaderLogin} alt="" /> */}
                    <span onClick={this.props.data.onClickHeaderLogin}>
                      <svg
                        version="1.1"
                        id="Layer_1"
                        x="0px"
                        y="0px"
                        width="200px"
                        height="200px"
                        viewBox="0 0 200 200"
                      >
                        <path
                          fill="#FFFFFF"
                          d="M101,53.479c-18.008,0-32.613,14.604-32.613,32.613c0,18.008,14.604,32.613,32.613,32.613  c18.009,0,32.612-14.604,32.612-32.613C133.612,68.083,119.009,53.479,101,53.479z"
                        ></path>
                        <path
                          fill="#FFFFFF"
                          d="M101,20.863c-45.028,0-81.536,36.505-81.536,81.539c0,45.028,36.508,81.536,81.536,81.536  c45.027,0,81.536-36.508,81.536-81.536C182.536,57.368,146.027,20.863,101,20.863z M35.771,102.401  c0-36.03,29.205-65.232,65.229-65.232c36.023,0,65.226,29.203,65.226,65.232c0,16.536-6.157,31.644-16.303,43.144  c-12.979-11.612-30.132-18.686-48.923-18.686c-18.792,0-35.944,7.073-48.916,18.686C41.932,134.045,35.771,118.944,35.771,102.401z"
                        ></path>
                      </svg>
                    </span>
                  </span>
                )
              ) : (
                []
              )}
              {/* <Menu
                    theme={"theme5"}
                    clickedTab={this.onClickTab}
                    onclickLogout={this.onClickLogout}
                    styles={this.props.data.menucssfile}
                    isopen={this.state.open}
                    MenuList={MenuList}
                    id={"main-menu"}
                    pathname={
                      this.props.data.pathname === "/myprofile"
                        ? new URLSearchParams(window.location.search).get(
                            "Linkindex"
                          ) !== null
                          ? this.props.data.pathname
                          : "myprofile"
                        : this.props.data.pathname
                    }
                    closeMenusHandler={this.onClickMenu}
                  /> */}

              {/* {(this.state.newToken != undefined && this.state.newToken != null && this.state.newToken != "") ?
                              <div className={this.props.data.cssfile.afterlogin}> <span className={this.props.data.cssfile.user_code}>{this.state.userFirststname}</span>
                                  <span onClick={() => { this.onClickArrow() }} >
                                      <img src="https://uat.elevatetrips.com/image/down_arrow.jpg" alt="" />
                                  </span>

                                  <div className={this.state.isShowPopup ? this.props.data.cssfile.show : this.props.data.cssfile.profile_details_hide} onMouseLeave={() => { this.onMouseLeave() }}>
                                      <span onClick={() => { this.onClickProfile() }}> <img type="image" src="https://www.intermilesresources.com/sharedresources/img/svg/flyout/links/myprofile.svg" alt="" />My Profile</span>
                                      <span onClick={() => { this.onClickLogout() }}> <img type="image" src="https://www.intermilesresources.com/sharedresources/img/svg/flyout/links/logout.svg" alt="" />Logout</span>
                                      <span> <img type="image" src="https://uat.elevatetrips.com/image/et-support.png" alt="" />Support</span>

                                  </div>
                              </div> : 
                              <span className={this.props.data.cssfile.login_btn} onClick={this.props.data.onClickHeaderLogin}>
                                  <img className={this.props.data.cssfile.login_icon} src="../images/profileOption.png" onClick={this.props.data.onClickHeaderLogin} />

                              </span>} */}
              {this.state.newToken != undefined &&
                this.state.newToken != null &&
                this.state.newToken != "" && (
                  <p className={this.props.data.cssfile.welcome_text}>
                    {/* Hi  */}
                    {/* {this.props?.data?.user?.first_name} */}
                  </p>
                )}
            </div>
            <div className={this.props.data.cssfile.branchlogomobo}>
              <Link
                title="Logo"
                key={"logo"}
                href={"/"}
                // onclick="window.location.href='/'"
                //onClick={() => { window.location.href = this.props.data.headermenu.supportlink }}
                className=""
              >
                <img
                  height="51"
                  width="81"
                  className={this.props?.data?.cssfile?.header_logo}
                  src={`${
                    "/shared/api/media/" +
                    this.props?.data?.site_id +
                    "/" +
                    (UploadLogo?._currentValue?.isLogo
                      ? this.props?.data?.headermenu?.mobile?.logo
                      : this.props?.data?.headermenu?.mobile?.logo)
                  }`}
                  alt="logo"
                />
              </Link>
            </div>
            <div className={this.props.data.cssfile.logo_header}>
              <ul className={this.props.data.cssfile.navbar_right}>
                <li
                  className={this.props.data.cssfile.dropdown}
                  style={{ display: "none" }}
                >
                  <span className={this.props.data.cssfile.dropdown_span}>
                    <img
                      src="/images/india-flag.png"
                      alt="flag"
                      //    width="20px"
                      //    height="20px"
                    />
                    {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 60 30"
                                width="1200"
                                height="600"
                              >
                                <clipPath id="s">
                                  <path d="M0,0 v30 h60 v-30 z" />
                                </clipPath>
                                <clipPath id="t">
                                  <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
                                </clipPath>
                                <g clipPath="url(#s)">
                                  <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
                                  <path
                                    d="M0,0 L60,30 M60,0 L0,30"
                                    stroke="#fff"
                                    strokeWidth="6"
                                  />
                                  <path
                                    d="M0,0 L60,30 M60,0 L0,30"
                                    clipPath="url(#t)"
                                    stroke="#C8102E"
                                    strokeWidth="4"
                                  />
                                  <path
                                    d="M30,0 v30 M0,15 h60"
                                    stroke="#fff"
                                    strokeWidth="10"
                                  />
                                  <path
                                    d="M30,0 v30 M0,15 h60"
                                    stroke="#C8102E"
                                    strokeWidth="6"
                                  />
                                </g>
                              </svg> */}
                    <div className={this.props.data.cssfile.znth_main}>
                      <span>IN</span>
                      <span className={this.props.data.cssfile.divider_line}>
                        |
                      </span>
                      <span>EN</span>
                      <span className={this.props.data.cssfile.divider_line}>
                        |
                      </span>
                      <span>INR</span>
                      {/* <span className={this.props.data.cssfile.drop_arrow}>
                            ▾
                          </span> */}
                      {/* <span
                                ref={this.setCurrencyWrapperRef}
                                onClick={() => {this.setState({ openCurrencyPopup: true });}} 
                                className={this.props.data.cssfile.dropZ_arrow}>▾</span> */}
                    </div>
                    {this.state.openCurrencyPopup && (
                      <div
                        className={this.props.data.cssfile.language_dropMain}
                        style={{ display: "block" }}
                      >
                        <div
                          className={this.props.data.cssfile.language_mnCont}
                        >
                          <div
                            className={this.props.data.cssfile.language_wrap}
                          >
                            <div className={this.props.data.cssfile.lang_title}>
                              {" "}
                              Select Language
                            </div>
                            <input
                              type="radio"
                              id="english"
                              name="language"
                              value="english"
                              checked
                            />
                            <label
                              className={this.props.data.cssfile.lang_label}
                              for="english"
                            >
                              English
                            </label>
                          </div>
                          <div
                            className={this.props.data.cssfile.language_wrap}
                          >
                            <div className={this.props.data.cssfile.lang_title}>
                              {" "}
                              Select Currency
                            </div>
                            <input
                              type="radio"
                              id="currency"
                              name="currency"
                              value="currency"
                              checked
                            />
                            <label
                              className={this.props.data.cssfile.lang_label}
                              for="english"
                            >
                              INR
                            </label>
                          </div>
                        </div>
                        <div className={this.props.data.cssfile.apply_btn}>
                          <button>Apply</button>
                        </div>
                      </div>
                    )}
                    {/* <img src="/theme2/down_arrow.png" className={this.props.data.cssfile.drop_arrow} alt=""/> */}
                  </span>

                  {/* Language currency dropdown */}
                  <div
                    className={this.props.data.cssfile.dropdown_menu_wrap}
                    style={{ display: "none" }}
                  >
                    <div className={this.props.data.cssfile.language_drop}>
                      <div className={this.props.data.cssfile.language_label}>
                        Language
                      </div>
                      <span
                        className={this.props.data.cssfile.nation_title_wrap}
                      >
                        <img
                          src=""
                          className={this.props.data.cssfile.nation_flag}
                          alt="nation flag"
                        />
                        <span className={this.props.data.cssfile.nation_label}>
                          India
                        </span>
                      </span>

                      <div
                        className={
                          this.props.data.cssfile.country_drop_container
                        }
                        style={{ display: "none" }}
                      >
                        <div
                          className={this.props.data.cssfile.country_scroll_box}
                        >
                          <div
                            className={
                              this.props.data.cssfile.country_dtail_wrap
                            }
                          >
                            <ul>
                              <li
                                className={this.props.data.cssfile.country_name}
                              >
                                India
                              </li>
                              <li
                                className={this.props.data.cssfile.country_name}
                              >
                                UAE
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={this.props.data.cssfile.language_drop}>
                      <div className={this.props.data.cssfile.language_label}>
                        Currency
                      </div>
                      <span
                        className={this.props.data.cssfile.nation_title_wrap}
                      >
                        <img
                          src=""
                          className={this.props.data.cssfile.nation_flag}
                          alt="nation flag"
                        />
                        <span className={this.props.data.cssfile.nation_label}>
                          India
                        </span>
                      </span>

                      <div
                        className={
                          this.props.data.cssfile.country_drop_container
                        }
                        style={{ display: "none" }}
                      >
                        <div
                          className={this.props.data.cssfile.country_scroll_box}
                        >
                          <div
                            className={
                              this.props.data.cssfile.country_dtail_wrap
                            }
                          >
                            <ul>
                              <li
                                className={this.props.data.cssfile.country_name}
                              >
                                AED
                              </li>
                              <li
                                className={this.props.data.cssfile.country_name}
                              >
                                USD
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Language currency dropdown */}
                </li>
                <li className={this.props.data.cssfile.support}>
                  <div
                    className={this.props.data.cssfile.suport_cont}
                    ref={this.setSupportWrapperRef}
                  >
                    <div
                      className={this.props.data.cssfile.znth_support}
                      onClick={() => {
                        this.setState({
                          openSupportPopup: !this.state.openSupportPopup,
                        });
                      }}
                    >
                      {/* <span>Support</span> */}
                      <span className={this.props.data.cssfile.dropZ_arrow}>
                        <svg
                          version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          width="26.75px"
                          height="26.75px"
                          viewBox="0 0 26.75 26.75"
                        >
                          <g>
                            <path
                              fill="#FFFFFF"
                              d="M15.711,13.257c-0.538,0.747-1.286,1.306-2.334,1.306c-3.201,0-3.644-5.16-3.646-5.183V9.094
		c0.438-0.259,1.067-0.737,1.574-1.345c1.343,1.224,4.473,1.449,5.717,1.491l0.001,0.111c-0.002,0.025-0.106,1.198-0.554,2.427
		c0.676-0.081,1.377-0.196,1.968-0.364c-0.206-1.773-0.435-3.455-0.438-3.481c-0.002-0.021-0.013-0.039-0.02-0.058
		c0.032-0.463,0.028-0.89-0.016-1.172c-0.465-3.069-4.558-3-4.581-3.003C13.346,3.695,9.252,3.64,8.788,6.703
		C8.744,6.984,8.741,7.411,8.772,7.875C8.765,7.894,8.754,7.912,8.751,7.933c-0.006,0.044-0.597,4.39-0.729,6.491
		c-0.006,0.1,0.042,0.195,0.125,0.252c0.047,0.031,0.103,0.047,0.155,0.047c0.044,0,0.086-0.01,0.125-0.028
		c0.012-0.008,1.043-0.512,2.017-0.93c0.653,0.889,1.592,1.56,2.933,1.56c1.34,0,2.277-0.671,2.931-1.561
		c0.972,0.419,2.004,0.923,2.016,0.931c0.039,0.019,0.083,0.028,0.124,0.028c0.055,0,0.108-0.016,0.156-0.047
		c0.084-0.057,0.132-0.151,0.126-0.252c-0.029-0.456-0.08-1.02-0.142-1.621C17.753,13.042,16.689,13.18,15.711,13.257z"
                            />
                            <path
                              fill="#FFFFFF"
                              d="M20.009,8.897c-0.137-0.065-0.288-0.086-0.445-0.087c0.001-0.03,0.004-0.062,0.004-0.092
		c0-3.375-1.053-6.225-6.191-6.225c-5.14,0-6.191,2.85-6.191,6.225c0,0.03,0.003,0.062,0.003,0.092
		C7.03,8.811,6.88,8.832,6.743,8.897c-0.584,0.279-1.06,1.42-0.5,2.619c0.391,0.834,1.171,0.705,1.619,0.543
		c0.031-0.287,0.065-0.573,0.099-0.858c-0.132-0.585-0.079-1.107,0.011-1.494l0.004-0.001c0-0.004-0.001-0.008-0.002-0.012
		C8.07,9.287,8.203,9.026,8.203,9.026C8.099,8.991,7.999,8.959,7.9,8.93C7.898,8.858,7.892,8.789,7.892,8.718
		c0-3.124,0.898-5.533,5.484-5.533c4.587,0,5.483,2.409,5.483,5.533c0,0.07-0.006,0.14-0.009,0.211
		c-0.099,0.03-0.199,0.061-0.301,0.097c0,0,0.132,0.26,0.228,0.667c0,0.005,0,0.008,0,0.015h0.004
		c0.114,0.494,0.166,1.211-0.148,1.996c-1.076,0.4-3.186,0.554-4.516,0.598c-0.169-0.158-0.432-0.266-0.74-0.266
		c-0.516,0-0.933,0.282-0.933,0.627c0,0.346,0.417,0.627,0.933,0.627c0.329,0,0.605-0.124,0.771-0.297
		c1.334-0.044,4.023-0.211,5.145-0.832c0.425,0.061,0.927-0.027,1.215-0.646C21.066,10.316,20.594,9.175,20.009,8.897z"
                            />
                            <path
                              fill="#FFFFFF"
                              d="M21.65,22.043c-0.577-1.974-1.057-4.33-1.925-5.195c-0.865-0.867-2.934-1.926-2.934-1.926
		c0.006,0.495-0.063,0.961-0.176,1.402c-1.866,1.573-4.614,1.574-6.481,0c-0.113-0.442-0.183-0.907-0.175-1.402
		c0,0-2.07,1.059-2.936,1.926c-0.865,0.865-1.348,3.222-1.925,5.195c-0.578,1.972,0.338,2.212,0.961,2.212h7.315h7.313
		C21.313,24.255,22.229,24.015,21.65,22.043z M13.377,20.634c0,0-1.667-1.063-2.672-2.884c0.836,0.424,1.752,0.639,2.67,0.639
		s1.835-0.216,2.672-0.639C15.042,19.571,13.377,20.634,13.377,20.634z M19.027,21.319h-3.082v-1.075h3.082V21.319z"
                            />
                          </g>
                        </svg>{" "}
                        ▾
                      </span>
                    </div>
                    {this.state.openSupportPopup && (
                      <div
                        className={this.props.data.cssfile.supportdropNew}
                        style={{ display: "block" }}
                      >
                        <a
                          href={
                            localStorage.getItem("appType") == "mobileapp"
                              ? "/mobileAppLink?page=supportNo&value=" +
                                this.props?.data?.siteData?.site?.support_number
                              : `tel:${this.props?.data?.siteData?.site?.support_number}`
                          }
                        >
                          <div
                            className={this.props.data.cssfile.header_menuZth}
                          >
                            <img src="/images/et-hd-phn.png" alt="" />
                            {/* +971 58 953 9988 */}
                            {this.props?.data?.siteData?.site?.support_number}
                          </div>
                        </a>
                        <a
                          href={
                            localStorage.getItem("appType") == "mobileapp"
                              ? "/mobileAppLink?page=supportEmail&value=" +
                                this.props?.data?.siteData?.site?.support_email
                              : `mailto:${this.props?.data?.siteData?.site?.support_email}`
                          }
                        >
                          <div
                            className={this.props.data.cssfile.header_menuZth}
                          >
                            <img
                              src="/images/et-hd-email.png"
                              alt=""
                              width="20px"
                              height="20px"
                            />
                            {/* connect@elevatetrips.com */}
                            {this.props?.data?.siteData?.site?.support_email}
                          </div>
                        </a>
                      </div>
                    )}
                  </div>
                </li>

                <li className={this.props.data.cssfile.dropdown}>
                  {/* <a href="#"> 
                              <img src="/images/profile-01.svg" className={this.props.data.cssfile.profile_icon} />
                              <span> My Account</span> 
                              <img src="/images/down_arrow.jpg" className={this.props.data.cssfile.drop_arrow} />
                            </a>  */}

                  {/* Login signup dropdown old */}
                  <div
                    className={this.props.data.cssfile.account_container}
                    style={{ display: "none" }}
                  >
                    <ul className={this.props.data.cssfile.drop_my_account}>
                      <li className={this.props.data.cssfile.login}>
                        <a href="#" title="Login">
                          <span>
                            {/* <img src="/images/profile-01.svg" className={this.props.cssfile.user_icon} /> */}
                            Login
                          </span>
                        </a>
                      </li>
                      <li className={this.props.data.cssfile.signup}>
                        <a href="#" title="Sign Up">
                          <span>
                            {/* <img src="/images/profile-01.svg" className={this.props.cssfile.user_icon} /> */}
                            Sign Up
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>

                  {/* Login signup dropdown */}
                </li>
              </ul>
            </div>
          </div>
        )}
      </header>
    );
  }
}

export default MobileHeader1;
